import { render } from "./aboutConsult.vue?vue&type=template&id=5239742f"
import script from "./aboutConsult.vue?vue&type=script&lang=js"
export * from "./aboutConsult.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__